import styled, {css, FlattenSimpleInterpolation} from 'styled-components'
import {airBlue, white, mediumGray} from '@modifi/colors'
import {media, Small, Col, Row} from '@modifi/ui'

type CircledNumberType = {
  completed: boolean
  enabled: boolean
}

export const CircledNumber = styled.div<CircledNumberType>`
  border-radius: 50%;
  width: 24px;
  height: 24px;
  font-weight: 600;
  padding: 1px;
  background: ${({completed}): string => (completed ? airBlue : white)};
  border: 1px solid
    ${({completed, enabled}): string => (completed || enabled ? airBlue : mediumGray)};
  color: ${({completed, enabled}): string => {
    if (completed) return white
    if (enabled) return airBlue
    return mediumGray
  }};
  text-align: center;
  ${media.md`
    width: 32px;
    height: 32px;
    padding: 5px;
  `}
  svg {
    margin-top: 2px;
  }
`
type ProgressLineType = {
  completed: boolean
  isMobileResponsive?: boolean
}

const verticalProgressLineStyles = css`
  transform: rotate(90deg);
  margin-left: -8px;
`

export const ProgressLine = styled.hr<ProgressLineType>`
  width: 27px;
  ${media.md`
    width: 80px;
  `}
  ${media.lg`
    width: 156px;  
  `}
  ${media.xl`
    width: 240px;  
  `}
  border-top: 1px solid ${({completed}): string => (completed ? airBlue : mediumGray)};
  ${({isMobileResponsive}): FlattenSimpleInterpolation | string =>
    isMobileResponsive ? verticalProgressLineStyles : ''};
`

export const StepsLabel = styled(Small)<{enabled: boolean}>`
  ${({enabled}): string => (enabled ? `color: ${airBlue};` : '')};
`

const positionedRowStyle = css`
  ${media.md`
    position: relative;
  `}
`

const positionedColStyle = css`
  ${media.md`
    position: absolute;
    top: 100%;
    left: 50%;
    transform: translate(-50%, 8px);
    text-align: center;
    min-width: 54px;
  `}
  ${media.lg`
    min-width: 160px;
  `}
`

type IsMobileResponsiveProps = {
  isMobileResponsive?: boolean
}

export const PositionedRow = styled(Row)<IsMobileResponsiveProps>`
  ${({isMobileResponsive}): FlattenSimpleInterpolation | string =>
    isMobileResponsive ? positionedRowStyle : ''}
`

export const StyledItemCol = styled(Col)<IsMobileResponsiveProps>`
  padding: 0px 4px;

  :last-child {
    ${({isMobileResponsive}): FlattenSimpleInterpolation | string =>
      isMobileResponsive ? positionedColStyle : ''}
  }
`

export const Wrapper = styled.div`
  padding-left: 16px;
`
